<template>
    <div :class="[
        'component',
        'component__box',
        disabled ? 'component__box--disabled' : ''
    ]">
        <component-title
            class="component__box_title"
            :size="titleSize"
            :underline="false"
            :raw="true"
        >{{ title }}
        </component-title>
        <component-text class="component__box_content">{{ content }}</component-text>
        <template v-if="linksOutput">
            <ul :class="'component__box_links'">
                <li
                    v-for="(link, index) in linksOutput"
                    :key="index"
                >
                    <component-button
                        :name="`component-box-links-${link.name}`"
                        :to="link.to"
                        :text="true"
                        :size="'large'"
                        :bold="true"
                    >{{ link.name }}
                    </component-button>
                </li>
            </ul>
        </template>
        <template v-if="buttonActive">
            <div class="component__box_actions">
                <component-button
                    :to="to"
                    :disabled="disabled"
                    :size="'medium'"
                    :align="'left'"
                    :name="'component-box-actions-button'"
                    @click="emitClick"
                >{{ buttonText }}
                </component-button>
            </div>
        </template>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentTitle from '@/components/default/shared/ComponentTitle'

export default {
  name: 'component-box',
  components: { ComponentTitle, ComponentText, ComponentButton },
  props: {
    title: {
      type: String,
      required: true
    },
    titleSize: {
      type: String,
      default: 'big'
    },
    content: {
      type: String,
      required: true
    },
    links: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonActive: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: function () {
        return this.$t('shared.components.buttons.confirm')
      }
    },
    to: {
      type: Object
    }
  },
  computed: {
    linksOutput () {
      let linksArr = this.links ? JSON.parse(JSON.stringify(this.links)) : ''
      return linksArr.length ? linksArr.filter(obj => obj.visible !== undefined ? obj.visible : true) : null
    }
  },
  methods: {
    emitClick () {
      this.$emit('emit-click')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentbox";
</style>
